import { render, staticRenderFns } from "./PriceTableRow.vue?vue&type=template&id=77929c53&"
import script from "./PriceTableRow.vue?vue&type=script&lang=js&"
export * from "./PriceTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports